var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 64,
    viewBox: "0 0 66 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 0H7C3.13401 0 0 3.13401 0 7V57C0 60.866 3.13401 64 7 64H59C62.866 64 66 60.866 66 57V7C66 3.13401 62.866 0 59 0Z",
    fill: "#242635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25C52.4183 25 56 21.4183 56 17C56 12.5817 52.4183 9 48 9C43.5817 9 40 12.5817 40 17C40 21.4183 43.5817 25 48 25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 54C22.4183 54 26 50.4183 26 46C26 41.5817 22.4183 38 18 38C13.5817 38 10 41.5817 10 46C10 50.4183 13.5817 54 18 54Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkCube);
export default __webpack_public_path__ + "static/media/DarkCube.884d7d5d11190bd1ba8d3c92baf2584a.svg";
export { ForwardRef as ReactComponent };